var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedulerCluster({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#027D14",
    d: "M192 512a320 320 0 1 0 640 0 320 320 0 1 0-640 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulerCluster);
export default __webpack_public_path__ + "static/media/scheduler-cluster.76933a95947ceef540ec566082c5423f.svg";
export { ForwardRef as ReactComponent };